import React, {useState} from "react";
import Layout from "./Layout";
import {
    Button,
    Card,
    CardContent,
    CardMedia, Chip,
    Slide,
    Table, TableBody,
    TableContainer,
    TablePagination, TableRow,
    Typography
} from "@mui/material";
import BuyMeACoffee from "./BuyMeACoffee";
import blog_data from './Data/blogs';

const Readings = () => {
    const ListReads = () => {
        const reads = blog_data;

        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(5);

        // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reads.length) : 0;

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };

        return (
            <div style={{alignContent: 'center', marginTop: '5%'}}>
                <TableContainer>
                    <Table>
                        <TableBody>
                            {(rowsPerPage > 0
                                    ? reads.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : reads
                            ).map(item => (
                                <TableRow>
                                    <Card
                                        style={{display: 'flex', marginBottom: '2%', backgroundColor: '#1a1a1a',
                                            color: '#ffffff', width: '100%'}}>
                                        <CardContent style={{width: '100%', marginLeft: '2%'}}>
                                            <div style={{display: 'flex'}}>
                                                <div style={{textAlign: 'left'}}>
                                                    <Typography variant='h5' component='h6'>{item.title}</Typography>
                                                </div>
                                                <div className="ml-auto">
                                                    <Typography variant="body1">
                                                        Posted: {item.date}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div style={{marginTop: '2%'}}>
                                                <Typography variant='body1' component='body1'>
                                                    {item.summary}
                                                </Typography>
                                            </div>
                                            <div style={{display: 'flex'}}>
                                                <div style={{marginTop: '2%'}}>
                                                    <div style={{display: 'flex'}}>
                                                        {item.tags.map(tag => (
                                                            <Chip label={tag} className="text-white mr-2"
                                                                  variant="outlined"/>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="mt-3 ml-auto">
                                                    <a href={item.url}
                                                       target='_blank' rel='noreferrer'>
                                                        <Button style={{color: 'white'}} variant="outlined">
                                                            Read More
                                                        </Button>
                                                    </a>
                                                </div>
                                            </div>
                                        </CardContent>
                                        <CardMedia component='img'
                                                   image={item.banner}
                                                   style={{height: '150px', width: '150px', borderRadius: '50%',
                                                       marginTop: 'auto', marginBottom: 'auto', marginLeft: '2%'}}/>
                                    </Card>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination style={{color: 'white'}}
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={reads.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        )
    }

    const Reads = () => {
        return(
            <div style={{marginTop: '8%', color: '#ffffff', marginBottom: '5%'}}>
                <div className="container-fluid">
                    <Slide direction='left' in={true} style={{transitionDuration: 2000}}>
                        <Typography variant="h3" component="h3"
                                    style={{fontWeight: 600, marginBottom: '1%', textAlign: 'center'}}>
                            Blogs
                        </Typography>
                    </Slide>
                </div>
                <div className="container">
                    <ListReads />
                </div>
                <BuyMeACoffee />
            </div>
        )
    }

    return (
        <Layout>
            <Reads />
        </Layout>
    )
};

export default Readings;
